import { render, staticRenderFns } from "./panel-large.vue?vue&type=template&id=3375bb20&"
import script from "./panel-large.vue?vue&type=script&lang=js&"
export * from "./panel-large.vue?vue&type=script&lang=js&"
import style0 from "./panel-large.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/alpheios-core/alpheios-core/packages/components/node_modules/vue-loader/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3375bb20')) {
      api.createRecord('3375bb20', component.options)
    } else {
      api.reload('3375bb20', component.options)
    }
    module.hot.accept("./panel-large.vue?vue&type=template&id=3375bb20&", function () {
      api.rerender('3375bb20', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "vue/components/panel-large.vue"
export default component.exports